module.exports = __webpack_public_path__ + "static/media/login.fadc19c0.png";